function convert(fileData, logging, callback) {
  if (typeof callback !== "function") {
    console.error("No callback provided. Aborting!!");
    throw new Error("iCAL-PARSER: No callback provided. Aborting!!");
    
  }
  if (typeof fileData !== "string") {
    return callback(new Error("iCAL-PARSER: Invalid file data passed. Aborting!!"));
  }
  prepare(fileData, logging, callback);
}

function prepare(fileData, logging, callback) {
  try {
    let _obj = {},
      SPACE = " ",
      lines = fileData.split(/\r\n|\n|\r/),
      prevKey = null,
      startKeys = [],
      objArr = [],
      endKeys = [];

    // Procesar cada línea manualmente en lugar de usar async
    for (let i = 0; i < lines.length; i++) {
      let line = lines[i];
      if (!line.trim()) continue; // Ignorar líneas vacías
      
      let keys = line.split(":"),
        isMultiLine = (line[0] === SPACE),
        key = keys[0],
        value;

      // Reconstruct full value preserving colons (fixes ATTENDEE mailto:email, LOCATION with colons, SUMMARY with colons)
      value = keys.slice(1).join(':');

      prevKey = isMultiLine && prevKey || key;
      
      switch (key) {
        case "BEGIN":
          if (startKeys.length) {
            objArr.push(_obj);
          }
          _obj = {};
          startKeys.push(value);
          break;
        case "END":
          endKeys.push(value);
          break;
        default:
          if (isMultiLine) {
            if (_obj[prevKey]) {
              _obj[prevKey] += line.substring(1);
            } else {
              _obj[prevKey] = line.substring(1);
            }
          } else {
            // Accumulate duplicate keys as array (e.g. multiple ATTENDEEs with same role)
            if (key in _obj) {
              if (Array.isArray(_obj[key])) {
                _obj[key].push(value);
              } else {
                _obj[key] = [_obj[key], value];
              }
            } else {
              _obj[key] = value;
            }
          }
      }
    }

    if (startKeys.length) {
      objArr.push(_obj);
    }

    process(startKeys, endKeys, objArr, logging, callback);
  } catch (err) {
    console.error("Error in prepare function:", err);
    return callback(err);
  }
}

function process(startKeys, endKeys, objArr, logging, callback) {  
  try {
    // Crear un mapa para rastrear qué elementos ya han sido procesados
    let processed = new Set();
    let result = {};
    let nestedComponents = new Map(); // Para rastrear componentes anidados
    
    // Primera pasada: construir la jerarquía básica
    let i = 0;
    while (i < endKeys.length) {
      let endKey = endKeys[i];
      let startIdx = -1;
      
      // Buscar el índice correspondiente en startKeys, de atrás hacia adelante
      for (let j = startKeys.length - 1; j >= 0; j--) {
        if (startKeys[j] === endKey && !processed.has(j)) {
          startIdx = j;
          break;
        }
      }
      
      if (startIdx >= 0) {
        // Encontramos un par BEGIN/END correspondiente
        processed.add(startIdx);
        
        // Si es un componente raíz (como VCALENDAR)
        if (startIdx === 0) {
          result[endKey] = [objArr[startIdx]];
        } else {
          // Es un componente anidado, lo guardamos temporalmente
          nestedComponents.set(startIdx, { 
            type: endKey, 
            data: objArr[startIdx],
            parentIdx: findParentIndex(startIdx, startKeys, processed)
          });
        }
        
        // Avanzar al siguiente END
        i++;
      } else {
        // No se encontró un BEGIN correspondiente para este END, lo saltamos
        console.warn(`No matching BEGIN found for END: ${endKey}`);
        i++;
      }
    }
    
    // Segunda pasada: anidar los componentes
    for (let [idx, component] of nestedComponents) {
      if (component.parentIdx >= 0 && component.parentIdx < objArr.length) {
        let parent = objArr[component.parentIdx];
        
        // Asegurarse de que existe el array para este tipo de componente
        if (!parent[component.type]) {
          parent[component.type] = [];
        }
        
        // Añadir este componente al array de su tipo en el padre
        parent[component.type].push(component.data);
      }
    }
    
    // Si no tenemos un resultado y tenemos objetos, usamos el primero como raíz
    if (Object.keys(result).length === 0 && objArr.length > 0) {
      const rootType = startKeys[0] || "UNKNOWN";
      result[rootType] = [objArr[0]];
    }
    
    // Log del resultado para depuración
    if (logging) {
      if (result.VCALENDAR && result.VCALENDAR[0] && result.VCALENDAR[0].VEVENT) {
        console.info("iCAL-PARSER:", result.VCALENDAR[0].VEVENT.length, "events parsed");
      } else {
        console.info("iCAL-PARSER: 0 events found or events not in expected structure");
        console.info("Result structure:", Object.keys(result));
        if (result.VCALENDAR) {
          console.info("VCALENDAR keys:", Object.keys(result.VCALENDAR[0] || {}));
        }
      }
    }
    
    return callback(null, result);
  } catch (err) {
    console.error("Error in process function:", err);
    return callback(err);
  }
}

// Función auxiliar para encontrar el índice del componente padre
function findParentIndex(childIdx, startKeys, processed) {
  for (let i = childIdx - 1; i >= 0; i--) {
    if (!processed.has(i)) {
      return i;
    }
  }
  return -1;
}

export default {
  convert
};